/**
 * Excel 아이콘 SVG
 *
 * 크기 조절: className으로 w-*, h-* 클래스 사용
 * @example
 * ```tsx
 * <ExcelIcon className="w-8 h-8" />
 * <ExcelIcon className="w-12 h-12" />
 * ```
 */
export function ExcelIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      aria-label="Excel icon"
      role="img"
    >
      <title>Excel</title>
      <g id="Excel">
        <g id="Vector">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M28.781 4.38999H18.651V2L2 4.57322V27.1284L18.651 30V26.4576H28.781C29.0878 26.4731 29.3883 26.3664 29.6167 26.1608C29.8451 25.9551 29.9829 25.6673 30 25.3602V5.48636C29.9827 5.17944 29.8448 4.89185 29.6164 4.68642C29.388 4.48099 29.0876 4.37442 28.781 4.38999ZM28.941 25.5424H18.617L18.6 23.6511H21.087V21.4483H18.581L18.569 20.1467H21.087V17.9439H18.55L18.538 16.6423H21.087V14.4396H18.53V13.1379H21.087V10.9352H18.53V9.63354H21.087V7.43079H18.53V5.42829H28.941V25.5424Z"
            fill="#20744A"
          />
          <path d="M26.81 7.42779H22.487V9.63055H26.81V7.42779Z" fill="#20744A" />
          <path d="M26.81 10.9332H22.487V13.1359H26.81V10.9332Z" fill="#20744A" />
          <path d="M26.81 14.4386H22.487V16.6413H26.81V14.4386Z" fill="#20744A" />
          <path d="M26.81 17.9439H22.487V20.1467H26.81V17.9439Z" fill="#20744A" />
          <path d="M26.81 21.4493H22.487V23.652H26.81V21.4493Z" fill="#20744A" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.34719 10.6658L8.49319 10.5426L9.84219 14.2563L11.4362 10.3895L13.5822 10.2663L10.9762 15.5389L13.5822 20.8245L11.3132 20.6713L9.78119 16.6423L8.24819 20.5181L6.16319 20.3339L8.58519 15.6651L6.34719 10.6658Z"
            fill="white"
          />
        </g>
      </g>
    </svg>
  );
}
